import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div<{
  $isLast?: boolean;
  $isExistingTheme?: boolean;
}>`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-bottom: ${({ $isLast }) =>
    $isLast ? 'none' : '1px solid var(--border-soft)'};

  ${({ $isExistingTheme }) =>
    $isExistingTheme &&
    `
    cursor: pointer;
    &:hover {
      background-color: var(--surface-hover);
      
    }
    
  &:first-child:hover {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  
  &:last-child:hover {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  `}
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const RelationLabel = styled.div`
  ${typographyV2.bodySm};
`;

export const TypeLabel = styled.div<{ $themeTypeColors: string }>`
  color: ${({ $themeTypeColors }) => $themeTypeColors};
  ${typographyV2.bodyXs};
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleBase};
`;

export const TypeAndTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
      },
    },
  ],
})`
  width: 100%;
  height: 72px;
`;
